/** @jsxRuntime classic */
/** @jsx jsx */
import React, { Component } from "react";
import { connect } from "react-redux";
import { jsx, css } from "@emotion/core";

import { getTemplateById } from "../../reducers/template";

import ModuleSlider from "./HomeModules/ModuleSlider";
import ModuleSpecialOffers from "./HomeModules/ModuleSpecialOffers";
import ModuleTagsDiscounts from "./HomeModules/ModuleTagsDiscounts";
import ModuleBlogNewsletter from "./HomeModules/ModuleBlogNewsletter";
import ModuleLatestBestSellers from "./HomeModules/ModuleLatestBestSellers";
import ModuleTimeLimitedDiscount from "./HomeModules/ModuleTimeLimitedDiscount";
import ModuleBannerCarousel from "./HomeModules/ModuleBannerCarousel";
import ModuleServices from "./HomeModules/ModuleServices";
// import FeedatyWidget from "./FeedatyWidget/FeedatyWidget";

import Assistenza from "../../shared/Icons/Assistenza";
import PuntiRitiro from "../../shared/Icons/PuntiRitiro";
import Spedizione from "../../shared/Icons/Spedizione";
import Pagamenti from "../../shared/Icons/Pagamenti";

class Home extends Component {
  // componentDidMount() {
  //   this.props.getStoreById(2)
  // }
  render() {
    const {
      discounted,
      latest,
      bestSellers,
      loading,
      home,
      siteName,
      logoImage,
      hasBlog,
      tags,
      tagsDiscounts,
      posts,
      feedaty,
      primaryColor,
      secondaryColor,
      uiVariantMenu,
      uiVariantSlider,
      uiVariantSliderTagsSide,
      uiVariantBannerHeader,
      uiVariantBannerPromo,
      uiVariantThumbnail,
      uiVariantServices,
      uiVariantCountdown,
      uiVariantBlogNewsletter,
      uiVariantBannerCarousel,
      position1,
      position2,
      position3,
      position4,
      position5,
      position6,
      position7,
      position8,
      position9,
    } = this.props;

    const bottomSlides = [
      {
        id: 1,
        seoName: home.slider1Slide1SeoName,
        imgUrl: home.slider1Slide1Image,
        link: home.slider1Slide1Link,
      },
      {
        id: 2,
        seoName: home.slider1Slide2SeoName,
        imgUrl: home.slider1Slide2Image,
        link: home.slider1Slide2Link,
      },
      {
        id: 3,
        seoName: home.slider1Slide3SeoName,
        imgUrl: home.slider1Slide3Image,
        link: home.slider1Slide3Link,
      },
    ];

    const services = [
      {
        id: 1,
        title: "Aiuto e supporto",
        icon: <Assistenza />,
        url: "/pagine/contattaci",
      },
      {
        id: 2,
        title: "Punti di ritiro",
        icon: <PuntiRitiro />,
        url: "/pagine/condizioni-vendita",
      },
      {
        id: 3,
        title: "Consegne",
        icon: <Spedizione />,
        url: "/pagine/modalita-costi-spedizione",
      },
      {
        id: 4,
        title: "Pagamenti",
        icon: <Pagamenti />,
        url: "/pagine/pagamenti-accettati",
      },
    ];

    const getHomeModuleByValue = (module) => {
      switch (module) {
        case "slider":
          return (
            <section className="home-module">
              <ModuleSlider
                home={home}
                tags={tags}
                primaryColor={primaryColor}
                uiVariantBannerHeader={uiVariantBannerHeader}
                uiVariantSlider={uiVariantSlider}
                uiVariantSliderTagsSide={uiVariantSliderTagsSide}
              />
            </section>
          );
        case "special-offers":
          return (
            <section className="home-module">
              <ModuleSpecialOffers
                loading={loading}
                discounted={discounted}
                primaryColor={primaryColor}
                uiVariantThumbnail={uiVariantThumbnail}
              />
            </section>
          );
        case "tag-discounts":
          return !!tagsDiscounts && tagsDiscounts.length > 0 ? (
            <section className="home-module">
              <ModuleTagsDiscounts
                tagsDiscounts={tagsDiscounts}
                home={home}
                primaryColor={primaryColor}
                uiVariantBannerPromo={uiVariantBannerPromo}
              />
            </section>
          ) : null;
        case "blog-newsletter":
          return (
            <section className="home-module">
              <ModuleBlogNewsletter
                hasBlog={hasBlog}
                home={home}
                posts={posts}
                primaryColor={primaryColor}
                uiVariantBlogNewsletter={uiVariantBlogNewsletter}
              />
            </section>
          );
        case "latest-bestsellers":
          return (
            <section className="home-module">
              <ModuleLatestBestSellers
                loading={loading}
                latest={latest}
                bestSellers={bestSellers}
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                uiVariantMenu={uiVariantMenu}
                uiVariantThumbnail={uiVariantThumbnail}
              />
            </section>
          );
        case "time-limited-discount":
          return home.timeLimitedDiscount ? (
            <section className="home-module">
              <ModuleTimeLimitedDiscount
                home={home}
                primaryColor={primaryColor}
                uiVariantCountdown={uiVariantCountdown}
                uiVariantThumbnail={uiVariantThumbnail}
              />
            </section>
          ) : null;
        case "banner-carousel":
          return (
            <section className="home-module">
              <ModuleBannerCarousel
                slides={bottomSlides}
                primaryColor={primaryColor}
                uiVariantBannerCarousel={uiVariantBannerCarousel}
              />
            </section>
          );
        // case "feedaty":
        //   return feedaty.enabled && feedaty.widgetId ? (
        //     <section className="feedaty-section">
        //       <FeedatyWidget feedaty={feedaty} />
        //     </section>
        //   ) : null;
        case "services":
          return (
            <section className="home-module">
              <ModuleServices
                services={services}
                primaryColor={primaryColor}
                uiVariantServices={uiVariantServices}
              />
            </section>
          );
        default:
          return null;
      }
    };

    const homeStyle = css`
      section.home-module {
        padding: 35px 0;

        &.feedaty-section {
          padding: 0;
        }

        &:first-of-type {
          padding: 0 0 35px;
        }
      }
    `;

    // console.log("home", this.props);
    return (
      <div className="homepage" css={homeStyle}>
        {!!position1 && getHomeModuleByValue(position1)}
        {!!position2 && getHomeModuleByValue(position2)}
        {!!position3 && getHomeModuleByValue(position3)}
        {!!position4 && getHomeModuleByValue(position4)}
        {!!position5 && getHomeModuleByValue(position5)}
        {!!position6 && getHomeModuleByValue(position6)}
        {!!position7 && getHomeModuleByValue(position7)}
        {!!position8 && getHomeModuleByValue(position8)}
        {!!position9 && getHomeModuleByValue(position9)}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    discounted: state.template.singleTemplate.discounted,
    latest: state.template.singleTemplate.latest,
    bestSellers: state.template.singleTemplate.bestSellers,
    tags: state.template.singleTemplate.tags,
    tagsDiscounts: state.template.singleTemplate.tagsDiscounts,
    posts: state.template.singleTemplate.posts,
    loading: state.template.loading,
    home: state.template.singleTemplate.home,
    siteName: state.template.singleTemplate.siteName,
    logoImage: state.template.singleTemplate.logoImage,
    hasBlog: true,
    // feedaty: {
    //   enabled: state.template.singleTemplate.hasFeedaty,
    //   widgetId: state.template.singleTemplate.feedaty.widgetId,
    //   siteKey: state.template.singleTemplate.feedaty.siteKey,
    // },
    primaryColor: state.template.singleTemplate.brandColor,
    secondaryColor: state.template.singleTemplate.secondaryColor,
    uiVariantMenu: String(state.template.singleTemplate.menu),
    uiVariantSlider: String(state.template.singleTemplate.slider),
    uiVariantSliderTagsSide: String(
      state.template.singleTemplate.sliderTagsSide
    ),
    uiVariantBannerHeader: String(state.template.singleTemplate.bannerHeader),
    uiVariantBannerPromo: String(state.template.singleTemplate.bannerPromo),
    uiVariantThumbnail: String(state.template.singleTemplate.thumbnail),
    uiVariantServices: String(state.template.singleTemplate.services),
    uiVariantCountdown: String(state.template.singleTemplate.countdown),
    uiVariantBlogNewsletter: String(
      state.template.singleTemplate.blogNewsletter
    ),
    uiVariantBannerCarousel: String(
      state.template.singleTemplate.bannerCarousel
    ),
    position1: state.template.singleTemplate.position1,
    position2: state.template.singleTemplate.position2,
    position3: state.template.singleTemplate.position3,
    position4: state.template.singleTemplate.position4,
    position5: state.template.singleTemplate.position5,
    position6: state.template.singleTemplate.position6,
    position7: state.template.singleTemplate.position7,
    position8: state.template.singleTemplate.position8,
    position9: state.template.singleTemplate.position9,
  };
}

export default connect(mapStateToProps, { getTemplateById })(Home);
